/**
 * GameCell · KpiOverview 表格首列：游戏名称单元格
 *
 * - 游戏图标使用 cond 接口返回的 `cover` 字段
 * - 兜底使用 `DefaultImg.GAME`，加载/失败均自动切换
 * - 用 React.memo 减少父组件 re-render 时的重复渲染
 */
import React, { memo } from 'react';
import RenderImg from '@op/components/RenderImg';
import { DefaultImg } from '@op/constants/defaultImg';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';

const RANK_MEDALS: Record<number, string> = {
  1: TipOne,
  2: TipTwo,
  3: TipThree,
};

export interface IGameCellProps {
  /** 游戏名称（已从 cond 数据查找） */
  gameName: string;
  /** 游戏封面 URL（cond.cover 字段） */
  cover?: string;
  /** 发售日期（可选；当前 cond 接口未返回，预留） */
  releaseDate?: string;
  /** 「Release Date」i18n 文案 */
  releaseDateLabel?: string;
  /** 排名序号 */
  ranking?: number;
  onClick?:() => void;
}

function GameCellInner({
  gameName,
  cover,
  releaseDate,
  releaseDateLabel,
  ranking,
  onClick
}: IGameCellProps) {
  const medalSvg = ranking ? RANK_MEDALS[ranking] : undefined; 
  return (
    <div
      className="dbom-kpi-game-cell" 
      onClick={() => onClick?.()}
    >
      {ranking !== undefined && ranking !== null && (
        <div className="dbom-kpi-game-cell__ranking">
          {medalSvg ? (
            <img
              className="dbom-kpi-game-cell__ranking-medal"
              src={medalSvg}
              alt={`#${ranking}`}
            />
          ) : (
            <span className="dbom-kpi-game-cell__ranking-number">
              {ranking}
            </span>
          )}
        </div>
      )}
      <RenderImg
        className="dbom-kpi-game-cell__icon"
        coverImage={cover || ''}
        defaultImage={DefaultImg.GAME}
        mode="image"
      />
      <div className="dbom-kpi-game-cell__info">
        <div className="dbom-kpi-game-cell__name" title={gameName}>
          {gameName}
        </div>
        {releaseDate && (
          <div className="dbom-kpi-game-cell__sub">
            {releaseDateLabel ? `${releaseDateLabel}: ` : ''}
            {releaseDate}
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(GameCellInner);
